import { observer } from "mobx-react-lite";
import { useState } from "react";
import * as React from "react";
import { withStyles } from "src/decorators";
import { Text } from "src/components";
import { useTranslation } from "src/hooks";
import styled from "styled-components";

type IFilePickerProps = React.HTMLProps<HTMLInputElement> & {
  helperText?: React.ReactNode;
};

const InputWrapperEl = styled.div`
  align-items: center;
  border: 1px solid ${(p) => p.theme.colors.borders.active};
  border-radius: 2px;
  box-sizing: border-box;
  display: flex;
  height: 40px;
  padding: 0 12px;
  position: relative;
`;

const InputEl = styled.input`
  cursor: pointer;
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

const FilePickerBase = (props: IFilePickerProps) => {
  const {
    label,
    onChange,
    multiple,
    placeholder,
    helperText,
    ...other
  } = props;
  const [selectedFiles, setSelectedFiles] = useState<FileList>();

  const translate = useTranslation(require("./translations.json"));

  const _onChange = (e: any) => {
    const files = e.target?.files ?? [];
    onChange?.(files);
    setSelectedFiles(files);
  };

  const _placeholder = (() => {
    if (!selectedFiles?.length) {
      return placeholder || translate("placeholder");
    }
    if (selectedFiles.length > 1) {
      return translate("multi_select", [selectedFiles.length.toString()]);
    }
    return selectedFiles[0]?.name;
  })();

  return (
    <div>
      <Text marginBottomS fontSize="medium" fontWeight="demi">
        {label}
      </Text>
      <InputWrapperEl {...(other as any)}>
        <Text
          marginRightS
          color="primary"
          fontSize="medium"
          fontWeight="demi"
          whiteSpace="nowrap"
          style={{ padding: "0 12px" }}
        >
          {translate("cta")}
        </Text>
        <Text
          truncate
          fontWeight="book"
          style={{ padding: "0 12px", borderLeft: "1px solid grey" }}
        >
          {_placeholder}
        </Text>
        <InputEl type="file" onChange={_onChange} multiple={multiple} />
      </InputWrapperEl>
      {helperText}
    </div>
  );
};

FilePickerBase.displayName = "FilePickerBase";

export const FilePicker = withStyles(observer(FilePickerBase));

FilePicker.displayName = "FilePicker";
